<!-- 关于我们-公司介绍-公司地址 -->
<template>
	<div class="Address-warp">
		<div class="content">
			<div class="inner">
				<div class="title" id="boxContent">
					<span class="title-text">联系我们</span>
					<span class="title-desc">捷途慧声，期待与您合作</span>
				</div>
				<p class="address-title">杭州捷途慧声科技有限公司</p>
				<div class="address">
					<div class="address-left">
						<BaiduMap />
					</div>
					<div class="address-right" v-if="!isMobileEnd">
						<p class="address-right-img">
							<img
								v-lazy="footerGzh"
								:key="footerGzh"
								alt="公众号"
							/>
						</p>
						<p>关注公众号"捷途慧声"了解更多</p>
						<p>联系电话：0571-86929509</p>
						<p>电子邮箱：sales@jet-voice.com</p>
						<p>
							公司地址：杭州市余杭区数云路2号菜鸟智谷产业园二期B4号楼501、502室
						</p>
					</div>
					<div class="address-768-right" v-else>
						<div class="address-768-right-img">
							<img
								v-lazy="footerGzh"
								:key="footerGzh"
								alt="公众号"
							/>
						</div>
						<div class="address-768-right-text">
							<p>杭州捷途慧声科技有限公司</p>
							<p>关注公众号"捷途慧声"了解更多</p>
							<p>联系电话：0571-86929509</p>
							<p>电子邮箱：sales@jet-voice.com</p>
							<p>
								公司地址：杭州市余杭区数云路2号菜鸟智谷产业园二期B4号楼501、502室
							</p>
						</div>
					</div>
				</div>
				<p class="address-title">杭州捷途慧声科技有限公司沈阳分公司</p>
				<div class="address">
					<div class="address-left">
						<BaiduMapPoint />
					</div>
					<div class="address-right" v-if="!isMobileEnd">
						<p class="address-right-img">
							<img
								v-lazy="footerGzh"
								:key="footerGzh"
								alt="公众号"
							/>
						</p>
						<p>关注公众号"捷途慧声"了解更多</p>
						<p>联系电话：15502403389</p>
						<p>电子邮箱：fanb@jet-voice.com</p>
						<p>公司地址：沈阳市三好街五里河城C1单元801室</p>
					</div>
					<div class="address-768-right" v-else>
						<div class="address-768-right-img">
							<img
								v-lazy="footerGzh"
								:key="footerGzh"
								alt="公众号"
							/>
						</div>
						<div class="address-768-right-text">
							<p>杭州捷途慧声科技有限公司沈阳分公司</p>
							<p>关注公众号"捷途慧声"了解更多</p>
							<p>联系电话：15502403389</p>
							<p>电子邮箱：fanb@jet-voice.com</p>
							<p>公司地址：沈阳市三好街五里河城C1单元801室</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="left"></div>
		<div class="right"></div>
	</div>
</template>

<script>
import BaiduMap from './childCpn/BaiduMap'
import BaiduMapPoint from './childCpn/BaiduMapPoint'
export default {
	name: 'Address',
	data() {
		return {
			footerGzh: require('@/assets/img/info/gzh.png'),
		}
	},
	watch: {},
	mounted() {
		this.$nextTick(() => {
			this.toLocal()
		})
	},
	methods: {
		toLocal() {
			const Id = this.$route.query.id
			if (Id !== 'boxContent') return
			const toElement = document.getElementById(Id)
			if (toElement) toElement.scrollIntoView()
		},
	},
	components: {
		BaiduMap,
		BaiduMapPoint,
	},
	computed: {
		isMobileEnd() {
			return this.$store.state.isMobileEnd
		},
	},

	destroyed() {},
}
</script>
<style lang="scss" scoped>
.Address-warp {
	.center,
	.left,
	.right {
		float: left;
	}
	.left,
	.right {
		width: var(--page-gutter);
		background-color: #fff;
	}
	.center {
		width: 100%;
	}
	.left {
		margin-left: -100%;
	}
	.right {
		margin-left: calc(0px - var(--page-gutter));
	}
	.inner {
		margin: 0 var(--page-gutter);
	}
	.content {
		height: 1200px;
		padding: 118px 0 65px;
	}
	.address-title {
		font-size: 20px;
		font-weight: 550;
		text-align: left;
		margin-bottom: 20px;
	}
	.address {
		width: 100%;
		min-height: 400px;
		margin-bottom: 40px;
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		.address-left {
			width: 688px;
			height: 400px;
			border-radius: 20px;
			overflow: hidden;
			margin-bottom: 20px;
		}
		.address-right {
			margin-left: 20px;
			width: 540px;
			p {
				font-size: 14px;
				color: #333;
				text-align: left;
				line-height: 130%;
			}
			p:nth-child(3),
			p:nth-child(4) {
				margin: 20px 0;
			}
			.address-right-img {
				width: 140px;
				height: 140px;
				margin-bottom: 10px;
				img {
					width: 100%;
					height: 100%;
				}
			}
		}
	}
}
.title {
	width: 100%;
	margin-bottom: 60px;
	text-align: center;
	.title-text {
		height: 60px;
		font-size: 52px;
		font-family: 'PingFang SC', 'Source Han Sans SC', sans-serif;
		font-weight: 500;
		color: #333333;
		line-height: 60px;
		display: block;
	}
	.title-desc {
		display: inline-block;
		font-size: 24px;
		font-family: 'PingFang SC', 'Source Han Sans SC', sans-serif;
		font-weight: 400;
		color: #666666;
		line-height: 32px;
		margin-top: 12px;
	}
}

@media screen and (max-width: 768px) {
	.Address-warp {
		.left,
		.right {
			width: 16px;
		}
		.right {
			margin-left: -16px;
		}
		.inner {
			margin: 0 16px;
		}
		.content {
			height: auto;
			padding: 24px 0 40px;
		}
		.address-title {
			display: none;
		}
		.address {
			margin-bottom: 32px;
			&:last-child {
				margin-bottom: 0;
			}
			.address-left {
				width: 100%;
				height: 197px;
				margin-bottom: 24px;
			}
			.address-right {
				width: 100%;
				p {
					font-size: 12px;
				}
				.address-right-img {
					width: 5rem;
					height: 5rem;
				}
			}
			.address-768-right {
				display: flex;
				justify-content: space-around;
				align-items: flex-start;
				width: 100%;
				gap: 12px;
				&-img {
					flex-shrink: 0;
					width: 100px;
					height: 100px;
					img {
						width: 100%;
						height: 100%;
						display: block;
					}
				}
				&-text {
					flex: 1;
					min-width: 0;
					p {
						font-size: 8px;
						line-height: 14px;
						word-break: break-all;
					}
					p:nth-child(1) {
						font-size: 12px;
						font-weight: 700;
						margin: 6px 0 12px;
					}
				}
			}
		}
	}
	.title {
		.title-text {
			height: 24px;
			font-size: 16px;
			line-height: 24px;
		}
		.title-desc {
			font-size: 10px;
			line-height: 18px;
			margin-top: 4px;
		}
	}
}
</style>
